module.exports = __webpack_public_path__ + "img/studio_smart_care.2fb931bc.png";